module.exports = __webpack_public_path__ + "static/media/Refrigerated-Cargoes.a2efe77b.jpg";